import React, { Fragment } from "react";
import { connect } from "react-redux";
import * as actions from "../actions";
import FaSpinner from "../components/faSpinner/faSpinner";
import ContactForm from "../components/contactForm/contactForm";
import { bemClassesFromModifiers } from "../constants/misc";
import {
  Sidebar,
  SidebarHeader,
  SidebarViewAll,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../components/layouts/layout1";
import Title from "../components/title/title";
import Tag from "../components/tag/tag";
import SectionStart from "../components/sectionStart/sectionStart";
import withTracker from "./withtracker";
import AuthorizationHOC from "./AuthorizationHOC";
import { ALL_USERS } from "../constants/userGroups";
import withBreadCrumb from "./withBreadcrumb";
import StatusMessage from "../components/statusMessage/statusMessage";

class ContactFormHOC extends React.Component {
  onSubmit = (form) => {
    this.props.sendContactFormMessage({
      name: form.name || form["name"],
      message: form.message || form["message"],
      subject: form.subject || form["subject"],
      mail: form.mail || form["mail"],
    });
  };

  componentWillUnmount() {
    this.props.clearContactStatusMessages();
  }

  render() {
    const { loading, statusMessage, success, resetForm, clearResetForm } =
      this.props;
    return (
      <SectionStart>
        <SideBar>
          <SidebarLeft>
            <Fragment>
              <SidebarHeader>
                <Title type="small">
                  <Tag className="display-effect">CONTACT US</Tag>
                </Title>
                <Title type="descr">
                  <span>
                    If you have any question or you are willing to give us a
                    feedback, please do not hesitate to contact us
                  </span>
                </Title>
              </SidebarHeader>
              <SidebarViewAll />
            </Fragment>
          </SidebarLeft>
          <SidebarRight>
            <Fragment>
              {!loading && statusMessage ? (
                <StatusMessage modifiers={success ? ["success"] : ["fail"]}>
                  {statusMessage}
                </StatusMessage>
              ) : (
                <FaSpinner loading={loading} />
              )}
              <ContactForm
                clearContactStatusMessages={
                  this.props.clearContactStatusMessages
                }
                success={success}
                resetForm={resetForm}
                clearResetForm={clearResetForm}
                sendMessage={this.onSubmit}
              />
            </Fragment>
          </SidebarRight>
        </SideBar>
      </SectionStart>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.contact?.loading || false,
  statusMessage: state.contact?.contact?.message || "",
  success: state.contact?.contact?.success || false,
  resetForm: state.contact?.contact?.resetForm || false,
});

const mapDispatchToProps = (dispatch) => ({
  sendContactFormMessage: (payload) => {
    dispatch(actions.sendContactFormMessage(payload));
  },
  clearContactStatusMessages: (payload) => {
    dispatch(actions.clearContactStatusMessages(payload));
  },
  clearResetForm: (payload) => {
    dispatch(actions.clearResetForm(payload));
  },
});

export default withTracker(
  AuthorizationHOC(ALL_USERS)(
    connect(mapStateToProps, mapDispatchToProps)(ContactFormHOC)
  )
);
